<template>
<div>
    <div class="section_padding_half section_grayBorder">
        <!-- TODO: class name below - is it correct? -->
        <div :class="['careersSearchControls', { careersSearchControls_noSearch: !searchBox }, `m-flexBoxJustify_${justify}`]">
            <div class="search" v-for="(filterObj, index) in filterCategories" :key="index"><!-- v-if="filterObj.options" TODO: decide if this is how we handle filters -->
                <label :for="name" class="isVisuallyHidden">{{filterObj.label}}</label>
                <div class="select">
    <multi-select
	  @selectionChanged="updateValues"
      :options="options"
	  :disabled="!filterObj.options || !filterObj.options.length"
      :btnLabel="filterObj.headline"
      :selectOptions="filterObj.options"
	  :value="filterObj.values"/>
               </div>
            </div>
            <div v-if='searchBox' class="search">
                <input type="text" placeholder="Keyword" :name="queryInputName" aria-label="keyword search" autocomplete="off" class="search-textInput" @input="updateSearchString($event.target.value)" :value="defaultQuery" >
                <div class="search-searchIcon">
                    <i class="icon icon_search"></i>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import multiSelect from '../VueMultiSelect/vue-multi-select.vue';

export default {
  props: [
    'filterCategories',
    'updateSearchString',
    'onValueChosen',
    'searchBox',
    'itemsPresent',
    'justify',
    'queryInputName',
    'defaultQuery'
  ],
  
  data() {
    return {
	  values: [],
      options: {
		labelName: "value",
		renderTemplate(elem) {	return `${elem.value}`; 	},
        multi: true,
        groups: false,
      },
    };
  },
  
 methods: {
	updateValues(values, FilterName, Operation) {
	var val = '';
	var SelectAll = false;
	if(values.length != 0)
	{
	for (let i = 0; i < this.filterCategories.length; i++) {
        const category = this.filterCategories[i];
		if(category.options.length > 0)
		{
			if (category.options[0].text == FilterName)
			{
			if(category.options.length == values.length){	SelectAll = true; }
			break;
			}
		}
		}
		if(!SelectAll)
		{
			values.forEach(function (filterObj) 
			{
				if(val)
				{
				val = val + '*' + filterObj.value;
				}
				else
				{
				val = filterObj.value;
				}
			})
		}
	}

	if(Operation == "PUSH")
	{
	if(SelectAll)
		{
		this.onValueChosen(FilterName, "SELECTALL");
		}
	else
		{
		this.onValueChosen(FilterName, val);
		}
	}
	if(Operation == "POP")
	{
	if(val != '')
		{
		this.onValueChosen(FilterName, val);
		}
	else
		{
		this.onValueChosen(FilterName, "");
		}
	}
	  },
    },

  components: {
    multiSelect,
  },
  
};
</script>


